'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var extend = require('../util/extend');
var Level = require('../constant/level');
var Category = require('../constant/category');

var errKeys = ['project', 'pageUrl', 'realUrl', 'resourceUrl', 'category', 'sec_category', 'level', 'timestamp', 'content'];
var VALID_ATTR = ['rowNum', 'colNum', 'tags'].concat(errKeys);
/**
 * 错误模型
 * 
 * @param {string} project - 错误所在项目
 * @param {string} pageUrl - 错误聚合页面地址
 * @param {string} realUrl - 错误真实地址
 * @param {string} [resourceUrl] - 错误资源地址
 * @param {string} category - 错误类型jsError, resourceError, ajaxError
 * @param {string} sec_category - 错误名称，用户错误聚合
 * @param {string} level - 错误程度, 默认error, 分类info, debug, error, warn
 * @param {string} [content] - 错误详细日志信息
 * @param {Number} [rowNum] - 错误行
 * @param {Number} [colNum] - 错误列
 * @param {Number} timestamp - 时间戳
 * @param {Object} [tags] - 其他用户自定义信息
 * 
 * @class OwlError
 */

var OwlError = function () {
    function OwlError(data) {
        _classCallCheck(this, OwlError);

        if (!data) return;
        var key = void 0;
        for (key in data) {
            if (data.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        }
        this.parse(data);
    }

    _createClass(OwlError, [{
        key: 'parse',
        value: function parse() {
            if (!this.category) {
                this.category = Category.SCRIPT;
            }
            if (!this.level) {
                this.level = Level.ERROR;
            }
            if (!this.timestamp) {
                this.timestamp = +new Date();
            }
            if (!this.sec_category) {
                this.sec_category = 'default';
            }
        }
    }, {
        key: 'isEqual',
        value: function isEqual(other) {
            return this.sec_category === other.sec_category && this.resourceUrl === other.resourceUrl && this.colNum === other.colNum && this.rowNum === other.rowNum && this.content === other.content;
        }
    }, {
        key: 'update',
        value: function update(data) {
            for (var _key in data) {
                if (data[_key] !== undefined && VALID_ATTR.indexOf(_key) !== -1) {
                    this[_key] = data[_key];
                }
            }
            return this;
        }
    }, {
        key: 'updateTags',
        value: function updateTags(obj) {
            var tags = extend(this.tags || {}, obj);
            this.tags = tags;
            return this;
        }
    }, {
        key: 'toJson',
        value: function toJson() {
            var _this = this;

            var rowNum = this.rowNum;
            var colNum = this.colNum;
            var str = {};

            errKeys.map(function (key) {
                if (_this[key] !== undefined) {
                    str[key] = _this[key];
                }
            });

            if (str.category === Category.SCRIPT && rowNum && colNum) {
                str.dynamicMetric = {
                    rowNum: rowNum,
                    colNum: colNum
                };
            }
            if (this.tags) {
                str.dynamicMetric = extend(str.dynamicMetric || {}, this.tags);
            }
            return str;
        }
    }]);

    return OwlError;
}();

OwlError.LEVEL = Level;
OwlError.CATEGORY = Category;

module.exports = OwlError;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/error/model.js
// module id = 151
// module chunks = 0